/**
 * 设备类型只信 user-device（allDeviceUser / 传入的 devices），
 * 不要用 user-account-order 的 platform_type。
 *
 * @param {Object} [options]
 * @param {Array} [options.devices] - getAllUserDevice 列表；缺省读 localStorage.allDeviceUser
 * @param {Object} [options.deviceUser] - 当前选中 DeviceUser；缺省读 localStorage
 * @param {string|number} [options.deviceId] - 指定设备 id（如订单 row.device_id）
 * @returns {string|null}
 */
const resolveCurrentDevicePlatformType = ({ devices, deviceUser, deviceId } = {}) => {
  if (typeof window === 'undefined') return null

  let list = devices
  if (!Array.isArray(list)) {
    try {
      list = JSON.parse(localStorage.getItem('allDeviceUser') || '[]')
    } catch {
      list = []
    }
  }
  if (!Array.isArray(list) || list.length === 0) {
    return localStorage.getItem('currentMode') || null
  }

  let targetId = deviceId
  let username = null

  if (targetId == null || targetId === '') {
    let selected = deviceUser
    if (!selected) {
      try {
        selected = JSON.parse(localStorage.getItem('DeviceUser') || 'null')
      } catch {
        selected = null
      }
    }
    targetId = selected?.device_id ?? selected?.id ?? null
    username = selected?.username ?? selected?.iCloud_username ?? null
  }

  const matched =
    (targetId != null &&
      targetId !== '' &&
      list.find(
        item => String(item.id) === String(targetId) || String(item.device_id) === String(targetId)
      )) ||
    (username &&
      list.find(
        item =>
          String(item.iCloud_username || '').toLowerCase() === String(username).toLowerCase()
      )) ||
    null

  return matched?.platform_type || localStorage.getItem('currentMode') || null
}

export default resolveCurrentDevicePlatformType
